import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { Observable } from 'rxjs';

export interface Item {
  label: string;
  value: string;
}

export interface SelectOptions {
  items?: Item[];
  filter?: (value: string) => Observable<Item[]>;
}

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class SelectInputComponent {
  @Input()
  appearance?: 'fill' | 'outline' = 'outline';

  @Input()
  label: string = '';

  @Input()
  name: string = '';

  @Input()
  icon?: string = '';

  @Input()
  onChange?: (value: string) => void;

  @Input()
  selectOptions?: SelectOptions = { items: [] };

  items: Item[] = [];

  constructor() {}

  ngOnInit() {
    this.carregarItens();
  }

  carregarItens() {
    const items = this.selectOptions?.items || [];

    if (this.selectOptions?.filter) {
      this.selectOptions.filter('').subscribe((result) => {
        if (result) {
          this.items = [...items, ...result];
        }
      });
    } else {
      this.items = items;
    }
  }

  change(value: string) {
    if (this.onChange) {
      this.onChange(value);
    }
  }
}
